import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientJsonpModule, HttpClientModule, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';

import { environment } from './environments/environment';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { NgOtpInputModule } from 'ng-otp-input';
import { ServiceWorkerModule } from '@angular/service-worker';
import { RequestInterceptorService } from './app/shared/interceptor/request-interceptor.service';

import '@angular/compiler';
import { register } from 'swiper/element/bundle';
import { provideGraphQL } from './app/graphql.provider';
register();

if (environment.production) {
  enableProdMode();

  /*  To Disable console logs in production environment   */
  /*if(window){
    window.console.log = window.console.warn = window.console.info = function(){
      // Don't log anything.
    };
  }*/
}

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then(registrations => {
//     if (registrations.length > 0) {
//         const unregisterPromises = registrations.map(reg => reg.unregister());
//         Promise.all(unregisterPromises).then(() => {
//         console.log('Service worker(s) unregistered, reloading...');
//         window.location.reload();
//       });    
//     }  
//   });
// }

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      // HttpClientModule,
      HttpClientJsonpModule,
      IonicModule.forRoot(),
      AppRoutingModule,
      NgOtpInputModule,
      ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    ),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideAnalytics(() => getAnalytics()),
    provideHttpClient(withInterceptorsFromDi()),
    provideGraphQL(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    },
  ],
}).catch(err => console.log(err));

